export var TabTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: {
            '@media (hover: none)': {
                '&:hover': {
                    backgroundColor: "transparent"
                },
                '&.Mui-selected': {
                    '&:hover': {
                        backgroundColor: "transparent"
                    }
                },
            }
        },
    },
}); };
export default TabTheme;
//# sourceMappingURL=theme.js.map